// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7258587f","732":"6e904ea7","977":"60c67463"}[chunkId] + ".chunk.js";
};